var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Calendar',{attrs:{"customheight":"28px","issmall":true,"currentDate":_vm.currentDate,"loading":_vm.loading,"first-day":1,"all-events":_vm.events,"showWeekNumberFlag":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }